import * as React from 'react';

import { HeaderBottom } from '../layout/HeaderBottom';
import { HeaderTop } from '../layout/carousel/HeaderTop';
import { SectionServices } from '../layout/SectionServices';
import { SectionArticles } from '../layout/SectionArticles';
import { SectionNewDevelopment } from '../layout/SectionNewDevelopment';
import { SectionContact } from '../layout/SectionContact';
import { Overlap } from '../layout/Overlap';
import { Page } from '../layout/Page';
import { Seo } from '../../utils/seo/Index';
import { NewsSearchTypes } from '../../../client/types/generated/types';
import { SectionNewsCard } from '../layout/SectionNewsCard';
import styled from 'styled-components';
import { Query, QueryGetPageContentInputArgs } from '../../../client/types/generated/types';

//GrapQL
import { getAdminClient } from '../layout/admin/AdminApolloClient';
import { useQuery } from '@apollo/client';
import { PageContentType } from '../../../server/global/enum';
import { CONTENT_ITEM } from '../../../client/__graphql__/queries/page_content/getPageContent';

//const client = getAdminClient();

type GetPageItem = Pick<Query, 'getNdPageContent'>;
type GetPageItemVariables = QueryGetPageContentInputArgs;

const Home: React.FC = () => {
  const { data, loading } = useQuery<GetPageItem, GetPageItemVariables>(CONTENT_ITEM, {
    variables: { input: { urltag: '', type: PageContentType.HOME } },
    fetchPolicy: 'network-only'
    //client: client,
  });

  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, []);

  if (loading) {
    return null;
  }

  //'Nybygg - PrivatMegleren - Nordeas Eiendomsmeglerkjede'

  return (
    <>
      <Seo
        title={`Nybygg - PrivatMegleren - ${data?.getNdPageContent?.seo?.title}`}
        description={data?.getNdPageContent?.seo?.text ? data?.getNdPageContent?.seo?.text : undefined}
        image={data?.getNdPageContent?.seo?.image ? data?.getNdPageContent?.seo?.image : undefined}
      />
      <Page>
        <HeaderTop />
        <Overlap yPos={90} yPos2={0}>
          <HeaderBottom />
        </Overlap>

        <SectionArticles searchType={NewsSearchTypes.NYBYGGFRONTPAGE} article_type={'nybygg-nyheter'} small={false} />

        <SectionArticles searchType={NewsSearchTypes.NYBYGGFRONTPAGE} article_type={'nybygg-tjenester'} small={true} style={{ marginTop: '2em' }} />

        <SectionNewDevelopment showProperties showTitle />
      </Page>
    </>
  );
};

export default Home;
